var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.container] = true, _obj[_vm.$style.room] = _vm.$env.VUE_APP_DESIGNER, _obj )},[(_vm.panZoom)?_c('div',{ref:"viewport",class:_vm.$style.viewport},[_c('div',{ref:"content",class:_vm.$style['zoomable-content']},[_c('pinch-zoom',{ref:"pinchZoom",attrs:{"limitPan":true,"limitZoom":_vm.maxScale,"backgroundColor":'rgb(0, 0, 0, 0)',"minScale":_vm.minScale}},[_c('vue-pdf-embed',{attrs:{"source":{
          url: _vm.value,
          cMapUrl: _vm.cMapUrl,
          cMapPacked: true
        }}})],1)],1)]):_c('vue-pdf-embed',{attrs:{"source":{
    url: _vm.value,
    cMapUrl: _vm.cMapUrl,
    cMapPacked: true
  },"options":_vm.pdfOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }